<template>
  <router-view></router-view>
</template>

<script>
export default {
  data: () => ({
    parentRoute: "RegionalManagerAffiliates",
  }),

  created() {
    if (this.$route.name == this.parentRoute) {
      this.mainTab();
    }
  },

  watch: {
    $route(val) {
      if (val.name == this.parentRoute) {
        this.mainTab();
      }
    },
  },

  methods: {
    mainTab() {
      this.$router.push({ name: "RegionalManagerAffiliatesExtract" });
    },
  },
};
</script>